import useCurrentResourceCentre from "./useCurrentResourceCentre";

const useIsDaybookSubscribedInSuperAdmin = (): { isDaybookSubscribedInSuperAdmin: boolean } => {
  const rc = useCurrentResourceCentre();

  const daybook = rc?.subscriptions?.features?.daybook;

  return {
    isDaybookSubscribedInSuperAdmin: daybook?.subscribed ?? false // Default to false if not defined
  };
};

export default useIsDaybookSubscribedInSuperAdmin;
